import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'store/rootStore';

interface FormFields extends DefaultFormFields {
  fullName: FormControl<string>;
  email: FormControl<string>;
  eligibility: FormControl<string>;
  billing: FormControl<string>;
}

export default class CustomAuthorizedUserStore {
  rootStore: RootStore;

  form: FormController<FormFields>;
  activeUserId: number | undefined;

  setActiveUserId(newId: number | undefined): void {
    this.activeUserId = newId;
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.form = new FormController<FormFields>({
      fullName: new FormControl<string>('', { validations: ['validName'] }),
      email: new FormControl<string>('', { validations: ['isEmailValid'] }),
      eligibility: new FormControl<string>(''),
      billing: new FormControl<string>(''),
    });
    this.activeUserId = undefined;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
